import get from 'lodash-es/get';
import React from 'react';
import { useParams } from 'react-router-dom';

import ProductsForm from '../components/Products/ProductsForm';
import useAdGroup from '../hooks/useAdGroup';
import useContract from '../hooks/useContract';
import useProduct from '../hooks/useProduct';

function ProductPage() {
  const { adGroupId, productId } = useParams();

  const { data: adGroup } = useAdGroup(Number(adGroupId));
  const { data: product } = useProduct(Number(adGroupId), Number(productId));

  const contractId = get(adGroup, 'contract_id');
  const { data: contract } = useContract(Number(contractId));

  const advertiserId = get(contract, 'advertiser_id');

  return (
    <ProductsForm product={product} contractId={contractId} advertiserId={advertiserId} adGroupId={Number(adGroupId)} />
  );
}

export default ProductPage;
